
<template>
    <div class="tl xd-dia" id="klqcn75v_asd">
        <el-dialog
        title="提示"
        :visible.sync="klng99h4_dialog"
        width="800px"
        top="20vh"
        :append-to-body="true">
        <template slot="title">
            <!-- 头部图片区 -->
            <div class="dib query">
                <div class="dib img-box2"></div>
            </div>
            <div class="dib close" @click="closeQueryDialog">
                <img src="@/assets/img/close.png" alt="">
            </div>
        </template>
            <!-- 标题 -->
            <div class="tc mb15 pr" style="top:-15px;">
                <div class="mb10">
                    <span class="dib fs12i c9 mr10">-----</span>
                    <span class="dib fs20i c_theme fwb vm">{{ ast.klnildse_title[0].body[0].value }}</span>
                    <span class="dib fs12i c9 ml10">-----</span>
                </div>
                <!-- <div class="fs12i c9">{{ ast.kks6yhl6_info[0].body[0].value }}</div> -->
            </div>
            <!-- 标题 -->
            <div class="klniwvzn_title fs18i">{{ klq0tgty_title }}</div>
            <!-- 内容 -->
            <div class="klnj3tv9_notice" v-html="klq0tldf_content"></div>
            <!-- 最近公告 -->
            <!-- <div class="mt20 fwb fs12i">最近公告</div>
            <ul class="recent-notice">
                <li v-for="i in 3" :key="i">
                    <a href="" class="fs12i">全国采集临近，这类注射剂或被选中！
                        <span class="fr fs12i">2020-01-02</span>
                    </a>
                </li>
            </ul> -->
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return{
                klng99h4_dialog: false,
                klq0tgty_title: '',
                klq0tldf_content: '',
            }
        },
        methods:{
            handle_open(idVal) {
                this.$get('Announcement/detail',{
                    id:idVal
                }).then(rsp => {
                    if(rsp.data.state == 0){
                        this.klq0tgty_title = rsp.data.data.title;
                        this.klq0tldf_content = rsp.data.data.content;
                    }
                })
            },
            // 关闭询单dialog
            closeQueryDialog() {
                this.klng99h4_dialog = false;
            },
        }
    };
</script>

<style lang="less">
	@import (reference) "@/assets/less/base.less";
    .el-dialog{
        border-radius: 5px;
        // reset element
        .el-dialog__header{
            position: relative;
            .tc;
            // 自定义关闭按钮
            .close{
                position: absolute;
                right: -30px;
                top: 0;
                cursor: pointer;
                img{
                    width: 20px;
                }
            }
            // 自定义标题样式
            .query{
                background-color: #fff;
                border-radius: 80px;
                .pa;
                top: -75px;
                left: calc(50% - 75px);
                width: 150px;
                height: 150px;
                line-height: 150px;
                overflow: hidden;
                .tc;
                .img-box2{
                    background: url('~@/assets/img/notice.png') no-repeat;
                    width: 120px;
                    height: 120px;
                    margin-top: 15px;
                    .vm;
                    .pr;
                    left: 5px;
                }
            }
            .el-dialog__headerbtn{
                display: none;
            }
        }
        .el-dialog__body{
            padding-top: 20px;
            max-height: 500px;
            overflow: auto;
            position: relative;
            .el-form-item.is-error .el-input__inner{
                border-color: red;
            }
            
            .el-form-item.is-error .el-textarea__inner{
                border-color: red;
            }

            .el-input__inner,.el-textarea__inner{
                width: 280px;
                background-color: #f1f1f1;
                border: 1px solid #f1f1f1;
                border-radius: 2px;
            }
            .el-upload-list--picture .el-upload-list__item{
                width: 280px;
            }
            // 上传按钮
            .upload_btn{
                background-color: #f1f1f1;
                color: #666;
                border: none;
                padding: 5px 20px;
                border-radius: 2px;
            }
            // 提交按钮
            .sub_btn{
                width: 250px;
                .fwb;
                border-radius: 3px;
            }
            // 标题
            .klniwvzn_title{
                background-color: #ebebeb;
                line-height: 60px;
                .tc;
                .c3;
            }
            // 内容
            .klnj3tv9_notice{
                line-height: 25px;
                .mt20;
                padding: 0 20px;
                text-align: justify;
            }
            // 最近公告-内容
            .recent-notice{
                background-color: #ebebeb;
                padding: 10px;
                margin-top: 20px;
                line-height: 25px;
            }
        }
    }
</style>